import subtopicicon1 from "../../../../src/assets/socialglass/subtopicIcon1.svg";
import subtopic2 from "../../../../src/assets/socialglass/subtopicIcon2.svg";
import subtopicicon3 from "../../../../src/assets/socialglass/subtopicIcon3.svg";
import subtopicicon4 from "../../../../src/assets/socialglass/subtopicIcon4.svg";

const ArtistSection = ({
  id,
  name,
  submissions,
  description,
  avatarColor = "bg-gradient-to-br from-orange-400 to-purple-500",
}) => {
  const renderIcon = () => {
    switch (id % 4) {
      case 0:
        return <img src={subtopicicon1} alt="subtopic icon 1" />;
      case 1:
        return <img src={subtopic2} alt="subtopic icon 2" />;
      case 2:
        return <img src={subtopicicon3} alt="subtopic icon 3" />;
      case 3:
        return <img src={subtopicicon4} alt="subtopic icon 4" />;
      default:
        return null;
    }
  };

  return (
    <div className="flex h-auto space-x-2 rounded-lg p-2 text-left shadow-socialglass">
      {renderIcon()}
      <div className="flex flex-col">
        <h3 className="text-lg font-semibold text-gray-800">
          {name} - <span className="italic">mentioned {submissions} times</span>
        </h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
};

export default ArtistSection;
